module.exports = __webpack_public_path__ + "images/application/stats-empty-stats-e4be56db.jpg";